import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

import { MainService } from "src/app/app.service";
import { Tribe, TribePayload } from "src/app/interfaces/tribe";

/**
 * Erros não são tratados aqui: o interceptor do PO exibe a mensagem do backend
 * e o chamador recebe o HttpErrorResponse intacto (status 409 etc.).
 */
@Injectable()
export class TribeService {
  private readonly baseUrl = "/api/v2/tribe";

  constructor(
    private http: HttpClient,
    private mainService: MainService,
  ) {}

  list(): Observable<Array<Tribe>> {
    return this.http
      .get<Array<any>>(this.baseUrl, this.mainService.httpOptions)
      .pipe(map((res) => (res ?? []).map(this.normalize)));
  }

  create(payload: TribePayload): Observable<Tribe> {
    return this.http.post<any>(this.baseUrl, payload, this.mainService.httpOptions).pipe(map(this.normalize));
  }

  update(id: string, payload: TribePayload): Observable<Tribe> {
    return this.http.put<any>(`${this.baseUrl}/${id}`, payload, this.mainService.httpOptions).pipe(
      map(this.normalize),
      tap(() => this.refreshSessionIfMyTribe(id)),
    );
  }

  private refreshSessionIfMyTribe(id: string): void {
    if (id && this.mainService.userToken?.tribeID === id) {
      this.mainService.refreshSessionArea?.().subscribe();
    }
  }

  remove(id: string): Observable<unknown> {
    return this.http.delete(`${this.baseUrl}/${id}`, this.mainService.httpOptions);
  }

  private normalize = (raw: any): Tribe => ({
    id: raw?.id ?? raw?._id ?? "",
    tribe: raw?.tribe ?? "",
    areasCount: raw?.areasCount ?? 0,
    usersCount: raw?.usersCount ?? 0,
  });
}
